export const FETCH_CLAIMS_LOADING = 'FETCH_CLAIMS_LOADING';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const FETCH_CLAIMS_FAILURE = 'FETCH_CLAIMS_FAILURE';

export const UPDATE_CLAIM_LOADING = 'UPDATE_CLAIM_LOADING';
export const UPDATE_CLAIM_SUCCESS = 'UPDATE_CLAIM_SUCCESS';
export const UPDATE_CLAIM_FAILURE = 'UPDATE_CLAIM_FAILURE';

export const DELETE_CLAIM_LOADING = 'DELETE_CLAIM_LOADING';
export const DELETE_CLAIM_SUCCESS = 'DELETE_CLAIM_SUCCESS';
export const DELETE_CLAIM_FAILURE = 'DELETE_CLAIM_FAILURE';

export const ADD_CLAIM_LOADING = 'ADD_CLAIM_LOADING';
export const ADD_CLAIM_SUCCESS = 'ADD_CLAIM_SUCCESS';
export const ADD_CLAIM_FAILURE = 'ADD_CLAIM_FAILURE';